import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Package, PlusCircle, ShoppingBag, MessageSquare, LogOut, Store, Menu, X } from 'lucide-react';
import { useAuth } from '../context/AppContext';

const navItems = [
  { to: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/admin/products', icon: Package, label: 'Products' },
  { to: '/admin/products/add', icon: PlusCircle, label: 'Add Product' },
  { to: '/admin/orders', icon: ShoppingBag, label: 'Orders' },
  { to: '/admin/inquiries', icon: MessageSquare, label: 'Inquiries' },
];

export default function AdminLayout({ children, title }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);

  return (
    <div className="admin-layout">
      <div className="admin-topbar">
        <button className="admin-menu-btn" onClick={() => setOpen(true)}><Menu size={22} /></button>
        <span>Anvith Dazzle Admin</span>
      </div>

      {open && <div className="admin-overlay" onClick={() => setOpen(false)} />}

      <aside className={`admin-sidebar ${open ? 'open' : ''}`}>
        <div className="admin-brand">
          <div>
            <div className="admin-brand-title">Anvith Dazzle</div>
            <div className="admin-brand-sub">Admin Panel</div>
          </div>
          <button className="admin-close-btn" onClick={() => setOpen(false)}><X size={20} /></button>
        </div>

        <nav className="admin-nav">
          {navItems.map(({ to, icon: Icon, label }) => {
            const active = location.pathname === to;
            return (
              <Link key={to} to={to} onClick={() => setOpen(false)} className={`admin-nav-link ${active ? 'active' : ''}`}>
                <Icon size={18} />
                {label}
              </Link>
            );
          })}
        </nav>

        <div className="admin-bottom">
          <button onClick={() => navigate('/')}><Store size={15} /> View Store</button>
          <button onClick={() => { logout(); navigate('/admin/login'); }}><LogOut size={15} /> Logout</button>
        </div>
      </aside>

      <main className="admin-main">
        {title && <h1 className="admin-title">{title}</h1>}
        {children}
      </main>
    </div>
  );
}